import { ColliType } from '@frontend/colli/types';
import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ID = 'colli-type-select';

export const ColliTypeSelect = (props: Omit<SelectInputV2Props<ColliType>, 'options'>) => {
    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable}
            label={props.label || 'Type'}
            options={Object.entries(ColliType).map((c) => ({ value: c[1], label: c[1], display: getColliTypeLabelByType(c[1]) }))}
            value={props.value}
            onSelect={props.onSelect}
        />
    );
};

export function getColliTypeLabelByType(type: ColliType): React.ReactNode {
    switch(type) {
        case ColliType.CHILLED:
            return (<FormattedMessage
                id='colli.type.chilled'
                defaultMessage='Chilled'
            />);
        case ColliType.FROZEN:
            return (<FormattedMessage
                id='colli.type.frozen'
                defaultMessage='Frozen'
            />);
        case ColliType.HEATED:
            return (<FormattedMessage
                id='colli.type.heated'
                defaultMessage='Heated'
            />);
        case ColliType.LIVESTOCK:
            return (<FormattedMessage
                id='colli.type.livestock'
                defaultMessage='Livestock'
            />);
        case ColliType.STANDARD:
            return (<FormattedMessage
                id='colli.type.standard'
                defaultMessage='Standard'
            />);
        default:
            return '';
    }
}